// extracted by mini-css-extract-plugin
export default {"statusTag":"src-pages-Order-Components-StatusTag-css-module__statusTag--w9D+Q"};